<div class="grid" style="overflow-y : auto;">
    <sm-table class="col-12" [data]="table" (onCellClicked)="cellClicked($event)"></sm-table>
</div>
